import * as React from 'react';
import { Text } from '../../../common/components/text';
import { EHideOfferState } from '../../../store/hide_offer';
import { IGetTopPopupParams } from '../../offer_card_page/OfferCardPage';
import { TopPopupContainer } from '../../top_popup/container';
import { getPopupText } from './get_popup_text';

export function HideOfferTopPopup(props: IGetTopPopupParams) {
  const { status } = props;

  return (
    <TopPopupContainer isError={status === EHideOfferState.ERROR}>
      <Text>{getPopupText(props)}</Text>
    </TopPopupContainer>
  );
}
